<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-13 10:37:03
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-10 17:16:25
 * @name: 添加琴行
 * @Description: 添加琴行
 * @FilePath: \preSaleNafterSaleBackstage\src\components\pianoCompanyManage\dialog\add-piano-company.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <div>
    <addNeditDialog ref="addNeditDialog" title="添加琴行" @close="close">
      <template v-slot:form>
        <div class="line">
          <font class="label"><i class="warn">*</i>琴行名称:</font>
          <el-input
            class="input"
            v-model="form.name"
            placeholder="请输入琴行名称"
          ></el-input>
        </div>
        <div class="line">
          <font class="label">地址:</font>
          <el-select
            class="select-item"
            v-model="provinceSelected"
            placeholder="请选择省"
          >
            <el-option
              :label="item"
              :value="item"
              v-for="item in province"
              :key="item"
            ></el-option>
          </el-select>
          <el-select
            class="select-item"
            v-model="citySelected"
            placeholder="请选择市"
          >
            <el-option
              :label="item"
              :value="item"
              v-for="item in city"
              :key="item"
            ></el-option>
          </el-select>
          <el-select
            class="select-item"
            v-model="distSelected"
            placeholder="请选择区"
          >
            <el-option
              :label="item"
              :value="item"
              v-for="item in dist"
              :key="item"
            ></el-option>
          </el-select>
        </div>
        <div class="line">
          <font class="label">详细地址:</font>
          <el-input
            class="input"
            v-model="detail"
            placeholder="请输入详细地址"
          ></el-input>
        </div>
        <div class="line">
          <font class="label"><i class="warn">*</i>跟进销售:</font>
          <el-select
            class="input"
            v-model="form.belong_user_id"
            placeholder="请选择跟进销售"
          >
            <el-option
              v-for="item of pianoCompany.salers"
              :key="item.id"
              :label="item.realname"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <div class="line">
          <font class="label"><i class="warn">*</i>销售经理:</font>
          <el-select
            class="input"
            v-model="form.belong_muser_id"
            placeholder="请选择销售经理"
          >
            <el-option
              v-for="item of pianoCompany.managers"
              :key="item.id"
              :label="item.realname"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <!-- <div class="line">
          <font class="label"><i class="warn">*</i>最高额度:</font>
          <el-input
            class="input"
            v-model="form.credit_limit"
            placeholder="请输入最高额度"
          ></el-input>
          <font class="append">元</font>
        </div>
        <div class="line">
          <font class="label"><i class="warn">*</i>还款周期:</font>
          <el-select
            class="input"
            v-model="form.credit_month"
            placeholder="请选择还款周期"
          >
            <el-option
              v-for="item of pianoCompany.cycles"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
          <font class="append">月</font>
        </div> -->
        <font class="division">-------------主账号分配-----------------</font>
        <div class="line">
          <font class="label"><i class="warn">*</i>姓名:</font>
          <el-input
            class="input"
            v-model="form.contact_username"
            placeholder="请输入主账号姓名"
          ></el-input>
        </div>
        <div class="line">
          <font class="label"><i class="warn">*</i>联系电话:</font>
          <el-input
            maxlength="11"
            class="input"
            v-model="form.contact_mobile"
            placeholder="请输入联系电话"
          ></el-input>
        </div>
        <!-- <div class="line">
          <font class="label">商品权限:</font>
          <el-button type="text" @click="edit">编辑</el-button>
        </div> -->
      </template>
      <template v-slot:btnGroup>
        <el-button class="submit" type="primary" @click="submit"
          >确认</el-button
        >
      </template>
    </addNeditDialog>
    <!-- <jurisdiction ref="jurisdiction" @confirm="confirm"></jurisdiction> -->
  </div>
</template>
<script>
import addNeditDialog from "@/components/pianoCompanyManage/dialog/addNeditDialog.vue";
// import jurisdiction from "@/components/pianoCompanyManage/dialog/jurisdiction.vue";
import regionSelect from "@/mixins/regionSelect";
import { debounceation } from "@/utils/decorator";
export default {
  name: "addPianoCompany",
  components: {
    addNeditDialog,
    // jurisdiction,
  },
  mixins: [regionSelect],
  props: {
    pianoCompany: {
      type: Object,
    },
  },
  data() {
    return {
      form: {
        //表单信息
      },
      detail: "", //详细地址
    };
  },
  created() {
    this.initData();
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 初始化data
     */
    initData() {
      this.form = {
        name: "", //琴行名称
        belong_user_id: "", //跟进销售
        belong_muser_id: "", //销售经理
        // credit_limit: 0, //最高额度
        // credit_month: 1, //还款周期
        contact_username: "", //主账号姓名
        contact_mobile: "", //联系电话
      };
      this.detail = "";
      this.provinceSelected = "";
      this.citySelected = "";
      this.distSelected = "";
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 打开弹窗
     */
    open() {
      this.$refs.addNeditDialog.open();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 关闭弹窗回调
     */
    close() {
      this.initData();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 关闭弹窗
     */
    @debounceation(300)
    cancel() {
      this.$refs.addNeditDialog.close();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击确定
     */
    @debounceation(300)
    submit() {
      let address =
        this.provinceSelected +
        " " +
        this.citySelected +
        " " +
        this.distSelected +
        " " +
        this.detail;
      let form = { address, ...this.form };
      this.$emit("submit", form); //回传数据给父组件处理
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击编辑
     */
    @debounceation(300)
    edit() {
      this.$refs.jurisdiction.open();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 商品权限弹窗回传,当前未使用,先注释
     * @param {Object} obj 回传数据
     */
    // confirm(obj) {
    //   console.log(obj);
    // },
  },
};
</script>
<style lang="scss" scoped>
.division {
  margin-bottom: 20px;
  font-size: $Vars-font-miniTitle-size;
  color: $Vars-font-placeholder-color;
  align-self: flex-start;
}
.line {
  margin-bottom: 20px;
  width: 100%;
  height: $Var-height-mormal;
  @extend .extend-flex-start;
  .label {
    font-size: $Vars-font-miniTitle-size;
    color: $Vars-font-normal-color;
    width: 100px;
    text-align: left;
    flex-shrink: 0;
    position: relative;
    .warn {
      position: absolute;
      left: -10px;
      content: "*";
      color: red;
    }
  }
  .input {
    flex: 1;
  }
  .select-item {
    flex: 1;
    margin-left: 20px;
    &:nth-child(2) {
      margin-left: 0 !important;
    }
  }
  .append {
    font-size: $Vars-font-miniTitle-size;
    color: $Vars-font-normal-color;
    padding: 0 20px;
    flex-shrink: 0;
  }
}
.submit {
  width: $Var-button-width-normal;
}
</style>
